import dashedLine from '../images/dashed-curved-apply-filters-line-mobile.svg'
import filterIcon from '../../MapTableToggle/images/filter-icon-mobile.svg'
import { useEffect } from 'react'
import { select } from 'd3'

type MobileScreen3Props = {
  anchorRef: React.RefObject<HTMLDivElement>
}

const MobileScreen3 = ({ anchorRef }: MobileScreen3Props) => {
  const { width, x, y } = anchorRef.current?.getBoundingClientRect()!
  useEffect(() => {
    const ref = anchorRef.current
    select(ref).style('z-index', 1000)
    return () => {
      select(ref).style('z-index', 'initial')
    }
  }, [anchorRef])
  return (
    <div
      className="flex flex-col items-center gap-4 w-[170px] absolute"
      style={{
        left: `${width + x}px`,
        top: `${y - 205}px`,
      }}
    >
      <p className="text-orange font-decimal text-[26px]">Apply filters</p>
      <img src={dashedLine} alt="dashed line" className="flex self-start" />
      <div
        className="fixed bottom-0 left-0 justify-center items-center h-[80px]"
        id="screen3-container"
      >
        <div className="border-r-[1px] border-none flex p-4 justify-center items-center h-full">
          <img
            src={filterIcon}
            alt="Filter representation"
            className="w-[34px] h-[29px]"
          />
        </div>
      </div>
    </div>
  )
}
export default MobileScreen3
